import { render } from "./KategorijePage.vue?vue&type=template&id=63a5f24a"
import script from "./KategorijePage.vue?vue&type=script&lang=js"
export * from "./KategorijePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__